module.exports = __webpack_public_path__ + "img/playfair-display-v22-latin-700.65c55dba.svg";